

// --- Convenience inspection utilities ---

export const toType = (value: unknown) => typeof value

export const toRawType = (value: unknown) => Object.prototype.toString.call(value).slice(8, -1)

export const toRawTypeLC = (value: unknown) => toRawType(value).toLowerCase()

export const isUndefined = (value: unknown): value is undefined => value === undefined

export const isNull = (value: unknown) => value === null

export const isEmptyString = (value: unknown): value is '' => value === ''

export const isUndefinedOrNull = (value: unknown): value is undefined|null => isUndefined(value) || isNull(value)

export const isUndefinedOrNullOrEmpty = (value: unknown) => isUndefinedOrNull(value) || isEmptyString(value)

export const isFunction = (value: unknown) => toType(value) === 'function'

export const isBoolean = (value: unknown): value is boolean => toType(value) === 'boolean'

export const isString = (value: unknown): value is string => toType(value) === 'string'

export const isNumber = (value: unknown) => toType(value) === 'number'

export const isNumeric = (value: unknown) => /^[0-9]*\.?[0-9]+$/.test(String(value))

export const isPrimitive = (value: unknown) => isBoolean(value) || isString(value) || isNumber(value)

export const isArray = (arr: unknown): arr is Array<unknown> => Array.isArray(arr)

// Quick object check
// This is primarily used to tell Objects from primitive values
// when we know the value is a JSON-compliant type
// Note object could be a complex type like array, Date, etc.
export const isObject = (obj: unknown): obj is Record<string | number | symbol, unknown> => obj !== null && typeof obj === 'object'

// Strict object type check
// Only returns true for plain JavaScript objects
export const isPlainObject = (obj: unknown) => Object.prototype.toString.call(obj) === '[object Object]'

export const isDate = (value: unknown) => value instanceof Date

export const isEvent = (value: unknown) => value instanceof Event

export const isFile = (value: unknown) => value instanceof File

export const isRegExp = (value: unknown) => toRawType(value) === 'RegExp'

export const isPromise = (value: any) =>
  !isUndefinedOrNull(value) && isFunction(value.then) && isFunction(value.catch)
